StockListController.$inject = ['$scope', 'stockService'];
function StockListController($scope, stockService) {

    stockService.find()
        .then(result => {
            $scope.stock = result;
        });

    stockService.findStats()
        .then(result => {
            $scope.chart = {};
            $scope.chart.labels = _.map(result, (r) => r.risco);
            $scope.chart.data = _.map(result, (r) => r.total);
            $scope.chart.colors = ['#dd4b39', '#f39c12', '#00a65a', '#3c8dbc'];

        });
}
app.controller('StockListController', StockListController);

/**
 * Stock-PO Modal Controller
 */
stockPOModalController.$inject = ['$scope', '$uibModalInstance', 'stockService', 'modalData'];
function stockPOModalController($scope, $uibModalInstance, stockService, modalData) {
    const dateClicked = modalData.dateClicked;
    const materialId = modalData.materialId;
    $scope.materialName = modalData.materialName;

    $scope.pos = [];
    $scope.poSelected = '';
    $scope.dateClicked = dateClicked;
    $scope.pictures = [];
    $scope.posLoading = true;
    $scope.picturesLoading = false;

    stockService.getStockPOs(materialId, dateClicked)
        .then(result => {
            $scope.posLoading = false;
            $scope.pos = result;
        }).catch(err => { $scope.posLoading = false; return err; })

    function selectPO(poNumber, inspectionId) {
        if (!inspectionId) {
            alert.error("This PO is only available in P21");
            return;
        }

        $scope.poSelected = poNumber;
        $scope.picturesLoading = true;

        stockService.getStockPOsByInspection(materialId, inspectionId)
            .then(result => {


                $scope.picturesLoading = false;
                $scope.pictures = result;

            }).catch(err => { $scope.picturesLoading = false; return err; })
    }

    $scope.selectPO = selectPO;
    $scope.close = $uibModalInstance.close;
}
app.controller('stockPOModalController', stockPOModalController);

currentStockModalController.$inject = ['$scope', '$uibModalInstance', 'stockService', 'modalData'];
function currentStockModalController($scope, $uibModalInstance, stockService, modalData) {
    const dateClicked = modalData.dateClicked;
    const materialId = modalData.materialId;
    $scope.materialName = modalData.materialName;

    stockService.getDistributionCenterStock(materialId)
        .then(result => {
            $scope.locationStock = result
            $scope.totalStock = _.round(_.reduce(result, (sum, r) => {
                return sum + (r.QtyOnHand - r.QtyAllocated)
            }, 0))
        })

    $scope.close = $uibModalInstance.close;
}
app.controller('currentStockModalController', currentStockModalController);

/**
 * Stock Detail Controller
 */
StockDetailController.$inject = ['$scope', '$routeParams', '$window', '$uibModal', 'stockService', 'stockUtil'];
function StockDetailController($scope, $routeParams, $window, $uibModal, stockService, stockUtil) {
    const materialId = $routeParams.id;
    $scope.materialId = materialId;
    $scope.stockChart = {};
    $scope.backOrderSimulationChart = {};
    $scope.oldAgedSimulationChart = {};
    $scope.userSimulationChart = {};
    $scope.salesChart = {};
    $scope.salesChartData = {};
    $scope.poList = [];
    $scope.stockItem = {};
    $scope.sales = {};
    $scope.checkboxSplit = false;
    $scope.activeTabIndex = stockService.getActiveTab();
    $scope.datePicker = {};
    $scope.chartLoading = true;
    $scope.stockSalesChartLoading = false;
    $scope.salesChartLoading = false;
    $scope.geochartLoading = false;
    $scope.loadingSomething = false;
    $scope.posLoading = false;
    $scope.radioSales = 'zeroTo12';
    $scope.radioSimulation = 'DEFAULT_SIMULATION';
    $scope.currentMaterial = stockService.currentMaterial;
    $scope.userChartInput = {}
    $scope.userChartInput.simulatedAvgSales = $scope.stockItem.media_vendas * 30;
    $scope.userChartInput.interactivityCheckbox = true;

    let stockChartCache = void 0;
    let regionalSalesCache = void 0;
    let salesStockCache = void 0;
    let pointsClicked = [];

    $scope.datePicker.date = { startDate: null, endDate: null };
    $scope.datePicker.options = stockUtil.getDatepickerOptions(applyDateFilter)

    // finds stock list with materials
    stockService.find(materialId)
        .then(result => {
            $scope.stockList = result;
        });


    /**
    * Simulation Chart (Stock)
    */
    function handlePointClick(pointClicked, stockHistory, simulations) {
        const lastHistoryDate = moment(_.max(_.map(stockHistory, point => new Date(point.x)))).format('YYYY-MM-DD');
        const dateClicked = moment(pointClicked.point.x).format('YYYY-MM-DD');
        const isFirstSimulationDate = moment(_.min(_.map(_.flattenDeep(simulations), s => s.x))).isSame(dateClicked)

        // console.log(lastHistoryDate);
        // console.log(dateClicked);
        // console.log(moment(lastHistoryDate).isSame(dateClicked));
        // console.log(pointClicked.point.id);

        if ((pointClicked.point.id === 0 && moment(lastHistoryDate).isSame(dateClicked)) || isFirstSimulationDate) {
            return showCurrentStockModal(pointClicked);
        }
        if (pointClicked.point.id === 0) {
            return calculateMeanPoint(pointClicked, stockHistory);
        }
        if (_.includes([1, 2, 3, 4, 5, 6], pointClicked.point.id)) {
            return showPOModalPoint(pointClicked);
        }
    }

    function showCurrentStockModal(clicked) {
        const dateClicked = clicked.point.x;

        const modalInstance = $uibModal.open({
            controller: 'currentStockModalController',
            templateUrl: 'src/stock/stock-current-modal.html',
            keyboard: true,
            size: 'lg',
            animation: false,
            resolve: {
                modalData: function () {
                    const materialName = $scope.currentMaterial;
                    return { dateClicked, materialId, materialName };
                }
            }
        });
    }

    function calculateMeanPoint(clicked, stockHistory) {
        if ($scope.userChartInput.interactivityCheckbox == false) return;

        pointsClicked.push(clicked.point);
        if (pointsClicked.length > 1) {
            const lastTwoPointsClicked = _.takeRight(pointsClicked, 2);
            const highestDatePoint = _.max(_.map(lastTwoPointsClicked, lpc => lpc.x))
            const lowestDatePoint = _.min(_.map(lastTwoPointsClicked, lpc => lpc.x))
            const rangeBetweenTwoPoints = _.filter(stockHistory, (point) => {
                return new Date(point.x) >= new Date(lowestDatePoint)
                    && new Date(point.x) <= new Date(highestDatePoint);
            })

            // const averageStockInRange = _.round(_.meanBy(rangeBetweenTwoPoints, 'y'));
            // console.log(lastTwoPointsClicked[0].y);
            // console.log(lastTwoPointsClicked[1].y);
            // console.log('point - :',Math.abs(lastTwoPointsClicked[0].y - lastTwoPointsClicked[1].y));
            // console.log('lengh :',rangeBetweenTwoPoints.length);
            // console.log('---------')
            const averageStockInRange = _.round((Math.abs(lastTwoPointsClicked[0].y - lastTwoPointsClicked[1].y) / rangeBetweenTwoPoints.length) * 30)


            $scope.userChartInput.simulatedAvgSales = averageStockInRange

            // const message = 'Average stock between ' + moment(lowestDatePoint).format('MMM Do') +
            //     ' and ' + moment(highestDatePoint).format('MM Do') +
            //     ' is ' + averageStockInRange + ' sq. ft.';

            const message = 'Average stock between dates is:   ' +
                averageStockInRange.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                ' sq. ft.';

            $scope.stockChartStatus = message;
            $scope.$apply();
            pointsClicked = [];
            return;

        }
        return;
    }

    function showPOModalPoint(clicked) {
        const dateClicked = clicked.point.x;

        const modalInstance = $uibModal.open({
            controller: 'stockPOModalController',
            templateUrl: 'src/stock/stock-po-modal.html',
            keyboard: true,
            size: 'lg',
            animation: false,
            resolve: {
                modalData: function () {
                    const materialName = $scope.currentMaterial;
                    return { dateClicked, materialId, materialName };
                }
            }
        });
    }
    function createSimulationChart() {
        // not the first time the tab is clicked
        if (stockChartCache) {
        } else {
            Promise.all(
                [stockService.get(materialId),
                stockService.getChart(materialId)])
                .then(results => {
                    $scope.chartLoading = false;
                    $scope.currentMaterial = results[0].nome_material;

                    $scope.stockItem = results[0];
                    $scope.stockChart.data = [];
                    $scope.stockChart.options = stockUtil.getOptions(function (click) {
                        // handles clicks on different parts of the chart 
                        return handlePointClick(click, results[1].history, _.filter(results[1], r => r[0] && r[0].id != 0))
                    });

                    // month bars
                    $scope.stockChart.data.push(stockUtil.createBar($scope.stockItem, "#e98a7e"));
                    $scope.stockChart.data.push(stockUtil.createBar($scope.stockItem, "#e2c391"));
                    $scope.stockChart.data.push(stockUtil.createBar($scope.stockItem, "#87d0e2"));

                    // history chart
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].history, "red", "Stock"));

                    // reference lines
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 0, "red", true));
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 30, "#5a6e82", true));
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 60, "#5a6e82", true));
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 49, "#0073b7"));

                    // ----- other charts get same configurations
                    $scope.backOrderSimulationChart = _.cloneDeep($scope.stockChart);
                    $scope.backOrderSimulationChart.options = stockUtil.getOptions(function (ev) { console.log(ev) });

                    $scope.oldAgedSimulationChart = _.cloneDeep($scope.stockChart);
                    $scope.oldAgedSimulationChart.options = stockUtil.getOptions(function (ev) { console.log(ev) });

                    $scope.backOrderSimulationChart.data.push(stockUtil.createLine(results[1].simulation6, "#ffbf01", "Simulation 6"))
                    $scope.backOrderSimulationChart.data.push(stockUtil.createLine(results[1].simulation5, "#5bc606", "Simulation 5"))
                    $scope.backOrderSimulationChart.data.push(stockUtil.createLine(results[1].simulation4, "#242424", "Simulation 4"))

                    $scope.oldAgedSimulationChart.data.push(stockUtil.createLine(results[1].simulation9, "#ffbf01", "Simulation 9"))
                    $scope.oldAgedSimulationChart.data.push(stockUtil.createLine(results[1].simulation8, "#5bc606", "Simulation 8"))
                    $scope.oldAgedSimulationChart.data.push(stockUtil.createLine(results[1].simulation7, "#242424", "Simulation 7"))
                    // -----

                    // simulation
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].simulation3, "#ff7701", "Simulation 3"));
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].simulation2, "green", "Simulation 2"));
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].simulation1, "black", "Simulation 1"));


                    stockChartCache = _.cloneDeep($scope.stockChart); // caches data for future loads
                    stockService.setChart($scope.stockChart);
                });
        }
    }

    /**
     * User Simulation
     */
    function altUserSimuationChart(average) {
        if (average) {
            $scope.currentSimulatedValue = average

            let loadingAlert = toastr
                .info('<i class="fa fa-refresh fa-spin"></i> Generating simulation',
                'Info',
                { "timeOut": 0, "extendedTimeOut": 0 })

            stockService.getUserSimulationChart(materialId, average)
                .then(result => {
                    toastr.clear(loadingAlert)

                    $scope.userSimulationChart = _.cloneDeep($scope.stockChart)

                    $scope.userSimulationChart.data = _.filter($scope.userSimulationChart.data, element => {
                        return (element.key && _.toString(element.key) == 'Stock')
                    })

                    // bars
                    $scope.userSimulationChart.data.push(stockUtil.createBar({ media_vendas: average / 30, nome_material: $scope.currentMaterial }, "#e98a7e"));
                    $scope.userSimulationChart.data.push(stockUtil.createBar({ media_vendas: average / 30, nome_material: $scope.currentMaterial }, "#e2c391"));
                    $scope.userSimulationChart.data.push(stockUtil.createBar({ media_vendas: average / 30, nome_material: $scope.currentMaterial }, "#87d0e2"));

                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 0, "red", true));
                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 30, "#5a6e82", true));
                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 60, "#5a6e82", true));
                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 49, "#0073b7"));

                    $scope.userSimulationChart.data.push(stockUtil.createLine(result.simulation3, "#ff7701", "Simulation 3"));
                    $scope.userSimulationChart.data.push(stockUtil.createLine(result.simulation2, "green", "Simulation 2"));
                    $scope.userSimulationChart.data.push(stockUtil.createLine(result.simulation1, "black", "Simulation 1"));

                })
        }
    }

    function createUserSimulationChart(simulatedSales) {

        if (!simulatedSales) {
            return alert.error('Please enter a value to simulate')
        }
        let points = {};
        const sales = $scope.stockItem.media_vendas * 30;
        // simulatedSales = $scope.userChartInput.simulatedAvgSales
        stockService.getChart(materialId)
            .then(result => {
                points = result;

                // points.simulation1 = dateToValue(points.simulation1)

                points.simulation1 = createUserSimulation(points.simulation1, simulatedSales)

            })

        function createUserSimulation(points, simulatedSales) {
            // dates become values
            points = dateToValue(points)
            points = addPODiffs(points)

            const p1 = points[1];
            const p2 = points[2];

            const slope = slopeFromPoints(p1, p2)
            const newSlope = calculateEquivalentSlope(sales, slope, simulatedSales)
            console.log('points:', points);
            console.log('slope:', slope);
            console.log('new slope:', newSlope);

            let refPoint = points[0]
            let newPoints = _.map(points, (p, index) => {
                const isLast = _.findLastIndex(points) === points.length
                const isFirst = index === 0;
                const isBetween = !isFirst && !isLast

                if (isFirst) {
                    return p;
                } if (isBetween && p.point_order === 2) {
                    refPoint = p
                    p.y = points[index - 1].y + p.poQty

                    return p
                }
                if (isBetween && p.point_order != 2) {
                    let pX = p.x
                    let result = calculatePoint(refPoint, newSlope, pX)
                    p.x = result.x
                    p.y = result.y

                    return p
                }

                return p
            })

            newPoints = revertDateValues(newPoints)


            console.log('new points: ', newPoints);

            let userChart = _.cloneDeep($scope.stockChart)

            let t = newPoints
            userChart.data.push(stockUtil.createLine(t, "blue", "Simulation 99"))

            $scope.userSimulationChart = userChart
        }

        function addPODiffs(points) {
            return _.map(points, (p, index) => {
                if (p.point_order == 2) {
                    p.poQty = p.y - points[index - 1].y
                }
                return p
            })
        }

        function slopeFromPoints(p1, p2) {
            return (p2.y - p1.y) / (p2.x - p1.x)
        }

        function revertDateValues(points) {
            return _.map(points, p => {
                let pDay = new Date(p.day);
                p.x = pDay
                return p
            });
        }

        function dateToValue(points) {
            let i = 0;
            return _.map(points, (p, index) => {
                console.log('-----------avaliando ponto----------');
                const pX = p.x
                p.day = new Date(pX)
                let isAfterPO = (points[index - 1] && points[index - 1].point_order == 2)
                let isBeforePO = (points[index + 1] && points[index + 1].point_order == 2)

                if (points[index - 1] && p.point_order != 2) {
                    let d1 = moment(points[index - 1].day).format('YYYY-MM-DD')
                    let d2 = moment(p.day).format('YYYY-MM-DD')
                    i = i + Math.abs(moment(d1).diff(moment(d2), 'days'))
                }
                p.x = i
                return p
            })
        }

        function calculateEquivalentSlope(actualSales, actualSalesSlope, simulatedSales) {
            return (actualSalesSlope * simulatedSales) / actualSales;
        }


        function calculatePoint(point, slope, x) {
            let y = point.y + (slope * (x - point.x))
            if (y < 0) y = 0
            return { x: x, y: y }
        }

    }

    function createBackOrderSimulation() {
        // alert.info('This feature is undergoing maintenance and will available soon')
    }

    /**
     * Geochart (Regional Sales)
     */
    function applyDateFilter(event) {
        const start = moment(event.model.startDate).format('YYYY-MM-DD');
        const end = moment(event.model.endtDate).format('YYYY-MM-DD');

        createGeochart(start, end);
    }

    function createGeochart(startDate, endDate) {
        $scope.geochartLoading = true;
        if (regionalSalesCache && !(startDate)) {
            // stockUtil.drawGeochart(regionalSalesCache, () => $scope.geochartLoading = false);
        } else {
            stockService.getRegionalSalesChart(materialId, startDate, endDate)
                .then(result => {
                    const hasSales = _.isArray(result) && !_.isEmpty(result);
                    if (!hasSales) alert.error("No sales for this period");
                    if (hasSales) {
                        regionalSalesCache = result;
                        stockUtil.drawGeochart(result, () => $scope.geochartLoading = false);
                    }
                })
        }
    }

    /**
     * Sales Chart (Monthly Sales)
     */


    let salesChartData = void 0;

    $scope.initSalesChart = () => {
        if (!salesChartData) {
            getSalesChartData()
                .then(getSalesInfo)
                .then(create0To12Chart)

        }
    }

    function getSalesChartData() {
        const twoYearsBack = moment().subtract(23, 'month').format('YYYY-MM-DD');
        const lastMonth = moment().format('YYYY-MM-DD');
        $scope.salesChartLoading = true;
        return stockService.getSalesChart(materialId, twoYearsBack, lastMonth)
            .then(data => {
                $scope.salesChartLoading = false;
                salesChartData = _.cloneDeep(data);
                return data;
            })
            .catch(err => { $scope.salesChartLoading = false; return err; })
    }

    function createStockSalesChart() {
        if (salesStockCache) {
            $scope.salesChart = {};
            $scope.salesChart = _.cloneDeep(salesStockCache);
            return;
        }

        $scope.stockSalesChartLoading = true;
        let dates = [];
        let cd = { data: [], options: {} };
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = 0;

        // options
        cd.options = stockUtil.salesChartOptionsLine;
        cd.options.chart.xAxis.ticks = 12;
        cd.options.chart.yDomain = [yMin, yMax];
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }
        cd.options.chart.bars = {};
        cd.options.chart.bars.yDomain = [yMin, yMax];
        cd.options.chart.color = ['#39CCCC'];

        // data
        cd.data.push({})
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = 'Sales'
        // cd.data[0].yAxis = 1;
        let i = 0;
        cd.data[0].values = _.map(_.slice(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        });

        $scope.salesChart = cd;

        let endDate = moment().format('YYYY-MM-DD');
        let startDate = moment().startOf('month').subtract(11, 'month').format('YYYY-MM-DD');

        stockService.getStockHistory(materialId, startDate, endDate)
            .then(result => {
                $scope.stockSalesChartLoading = false;
                let historyValues = _.map(result, m => { return { x: 0, y: m.media_mensal } });

                $scope.salesChart.data.push({})
                $scope.salesChart.data[1].color = '#D81B60';
                $scope.salesChart.data[1].type = 'line'
                $scope.salesChart.data[1].key = 'Stock'
                // $scope.salesChart.data[1].yAxis = 1;
                $scope.salesChart.data[1].classed = 'dashed-line';

                // enable if bars
                // $scope.salesChart.data.push({});
                // $scope.salesChart.options.chart.x = function (d, i) { return i };
                // $scope.salesChart.data[1].key = 'Stock'
                // $scope.salesChart.data[1].bar = true;
                // $scope.salesChart.data[1].yAxis = 1;

                let maxHistoryValues = _.max(_.map(result, 'media_mensal'))
                if (yMax < maxHistoryValues) {
                    yMax = maxHistoryValues;
                }

                $scope.salesChart.options.chart.yDomain = [yMin, yMax];
                // $scope.salesChart.options.chart.bars.yDomain = [yMin, yMax];

                let history12Months = _.concat(
                    _.fill(Array(12 - historyValues.length), { x: 0, y: 0 }),
                    historyValues
                );
                let i = 0;
                $scope.salesChart.data[1].values = _.map(history12Months, h => {
                    return { x: i++, y: h.y }
                });

                salesStockCache = _.cloneDeep($scope.salesChart);
            }).catch(err => { $scope.stockSalesChartLoading = false; return err })
    }

     function linearRegression(y, x) {
        // http://www.localwisdom.com/blog/2014/01/get-trend-line-javascript-graph-linear-regression/

        var lr = {}
        var n = y.length
        var sum_x = 0
        var sum_y = 0
        var sum_xy = 0
        var sum_xx = 0
        var sum_yy = 0

        for (var i = 0; i < y.length; i++) {

            sum_x += x[i];
            sum_y += y[i];
            sum_xy += (x[i] * y[i]);
            sum_xx += (x[i] * x[i]);
            sum_yy += (y[i] * y[i]);
        }

        lr['slope'] = (n * sum_xy - sum_x * sum_y) / (n * sum_xx - sum_x * sum_x);
        lr['intercept'] = (sum_y - lr.slope * sum_x) / n;
        lr['r2'] = Math.pow((n * sum_xy - sum_x * sum_y) / Math.sqrt((n * sum_xx - sum_x * sum_x) * (n * sum_yy - sum_y * sum_y)), 2);

        return lr
    }

    function create0To12Chart() {

        let dates = [];
        let cd = { data: [], options: {} };
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = 0;

        // options
        cd.options = stockUtil.getSalesChartOptions();
        cd.options.chart.xAxis.ticks = 12;
        cd.options.chart.yDomain = [yMin, yMax];
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }


        // data
        cd.data.push({})
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = 'Sales'
        cd.data[0].yAxis = 1;
        let i = 0;
        cd.data[0].values = _.map(_.slice(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })


           //
        // Trend line
        //
        let salesLinePoints = _.initial(cd.data[0].values)

        const known_x = _.map(salesLinePoints, 'x')
        const known_y = _.map(salesLinePoints, 'y')
        const result = linearRegression(known_y, known_x)

        cd.data.push({})

        if (result.slope < 0) cd.data[1].color = '#ff4040'
        if (result.slope >= 0) cd.data[1].color = '#16dc00'

        cd.data[1].type = 'line'
        cd.data[1].key = 'Trend'
        cd.data[1].yAxis = 1;
        cd.data[1].classed = 'dashed-line';
        let j = 0;
        cd.data[1].values = []

        cd.data[1].values.push({
            x: _.head(salesLinePoints).x,
            y: result.intercept
        })

        cd.data[1].values.push({
            x: _.last(salesLinePoints).x,
            y: (salesLinePoints.length * result.slope) + result.intercept
        })

        $scope.salesChart = cd;

    }

    function create0To24Chart() {
        let dates = [];
        let cd = { data: [{}], options: {} };
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = 0;

        // options
        cd.options = stockUtil.getSalesChartOptions();
        cd.options.chart.xAxis.ticks = 24;
        cd.options.chart.yDomain = [yMin, yMax];
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }

        //data
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = 'Sales'
        cd.data[0].yAxis = 1;
        let i = 0;
        cd.data[0].values = _.map(salesChartData, v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })

        cd.data.push({})
        cd.data[1].color = '#b5bbc8';
        cd.data[1].type = 'line'
        cd.data[1].key = 'Period division'
        cd.data[1].yAxis = 1;
        // cd.data[1].classed = '1';
        cd.data[1].values = [{ x: [12], y: yMax },
        { x: [12], y: 0 }]

         //
        // Trend line 1st Year
        //
        const salesLinePoints1stYear = _.take(cd.data[0].values, 13)

        const known_x = _.map(salesLinePoints1stYear, 'x')
        const known_y = _.map(salesLinePoints1stYear, 'y')
        const result = linearRegression(known_y, known_x)

        cd.data.push({})

        if (result.slope < 0) cd.data[2].color = '#ff4040'
        if (result.slope >= 0) cd.data[2].color = '#16dc00'

        cd.data[2].type = 'line'
        cd.data[2].key = 'Trend 1st Year'
        cd.data[2].yAxis = 1;
        cd.data[2].classed = 'dashed-line';
        cd.data[2].values = []

        cd.data[2].values.push({
            x: _.head(salesLinePoints1stYear).x,
            y: result.intercept
        })

        cd.data[2].values.push({
            x: _.last(salesLinePoints1stYear).x,
            y: (salesLinePoints1stYear.length * result.slope) + result.intercept
        })


         //
        // Trend line 2nd Year
        //
        const salesLinePoints2ndYear = _.takeRight(cd.data[0].values, 12)
        salesLinePoints2ndYear.pop()

        const known_x2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        const known_y2 = _.map(salesLinePoints2ndYear, 'y')
        const result2 = linearRegression(known_y2, known_x2)

        cd.data.push({})

        if (result2.slope < 0) cd.data[3].color = '#ff4040'
        if (result2.slope >= 0) cd.data[3].color = '#16dc00'

        cd.data[3].type = 'line'
        cd.data[3].key = 'Trend 2nd Year'
        cd.data[3].yAxis = 1;
        cd.data[3].classed = 'dashed-line';
        cd.data[3].values = []

        cd.data[3].values.push({
            x: _.head(salesLinePoints2ndYear).x,
            y: result2.intercept
        })

        cd.data[3].values.push({
            x: _.last(salesLinePoints2ndYear).x,
            y: (salesLinePoints2ndYear.length * result2.slope) + result2.intercept
        })

        $scope.salesChart = cd;
    }

    function createComparisonChart() {
        let cd = { data: [{}, {}], options: {} };
        let dates = [];
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = -5;

        cd.options = stockUtil.getSalesChartOptions();
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }
        cd.options.chart.yDomain = [yMin, yMax];

        // 0-12
        let i = 0;
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = '0-12'
        cd.data[0].yAxis = 1;
        cd.data[0].values = _.map(_.slice(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })
        cd.data[0].yAxis = 1;

        // 0-24
        i = 0;
        cd.data[1].color = '#dd4b39';
        cd.data[1].type = 'line'
        cd.data[1].key = '12-24'
        cd.data[1].yAxis = 1;
        cd.data[1].values = _.map(_.take(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })
        cd.data[0].yAxis = 1;

        $scope.salesChart = cd;
    }

    function getSalesInfo(data) {
        let y2 = _.meanBy(_.take(_.map(salesChartData, 'quantidade_sqft'), 12));
        let y1 = _.meanBy(_.slice(_.map(salesChartData, 'quantidade_sqft'), 12));

        $scope.sales = stockUtil.getSalesBehavior(y1, y2);
        $scope.sales.firstYearAverage = _.toString(y1);
        $scope.sales.secondYearAverage = _.toString(y2);
    }

    function clickMaterial(name) {
        stockService.currentMaterial = name;
    }


    let regionalStockCache;
    function createRegionalStockChart() {
        if (regionalStockCache) return;

        stockService.getRegionalStockChart(materialId)
            .then(result => {
                regionalStockCache = result
                stockUtil.drawRegionalStockChart(result, () => { })
            })

    }
    $scope.createRegionalStockChart = createRegionalStockChart

    $scope.clickMaterial = clickMaterial;

    $scope.createGeochart = createGeochart;
    $scope.setActiveTab = stockService.setActiveTab;
    $scope.createSimulationChart = createSimulationChart;
    $scope.createUserSimulationChart = createUserSimulationChart;
    $scope.createBackOrderSimulation = createBackOrderSimulation;

    $scope.create0To12Chart = create0To12Chart;
    $scope.create0To24Chart = create0To24Chart;
    $scope.createComparisonChart = createComparisonChart;
    $scope.createStockSalesChart = createStockSalesChart;

    $scope.altUserSimuationChart = altUserSimuationChart

}
app.controller('StockDetailController', StockDetailController);